const EXPIRATION_TIME_MINUTES = 60 * 24;
const EXPIRATION_TIME_SECONDS = EXPIRATION_TIME_MINUTES * 60;
const EXPIRATION_TIME_MS = EXPIRATION_TIME_SECONDS * 1000;


export const DAYS_OF_WEEK = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'] as const;


export { EXPIRATION_TIME_MINUTES, EXPIRATION_TIME_SECONDS, EXPIRATION_TIME_MS };
